var map = {
	"./akis.jpg": 2542,
	"./andi.jpg": 8116,
	"./david.jpg": 3911,
	"./falco.jpg": 3801,
	"./flo.jpg": 8243,
	"./fritz.jpg": 6931,
	"./gegge.jpg": 2272,
	"./geri.jpg": 7437,
	"./jürgen.jpg": 7975,
	"./lacky.jpg": 6069,
	"./martin.jpg": 1569,
	"./richard.jpg": 2089,
	"./stefan.jpg": 1110,
	"./stephan.jpg": 8100,
	"./thomas.jpg": 4386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2391;